import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class BringozSetTimeComponent implements IController {
  country: any;
  min: any;
  max: any;
  timestamp: any;
  ticks: any;
  amPm: any;
  onChange: Function;

  disabled = {
    hourUp: false,
    hourDown: false,
    minuteUp: false,
    minuteDown: false
  };

  minHour: any;
  minMinute: any;
  maxHour: any;
  maxMinute: any;
  hour: any;
  minute: any;

  constructor(private moment) {
  }

  $onInit() {
    if (_.isEqual(this.country, 'US')) {
      this.amPm = 'am';
    }
    this.initTimes();
    this.setDisability();
  };


  $onChanges(changes) {
    if (changes.timestamp && !changes.timestamp.isFirstChange()) {
      this.$onInit();
    }
    if (changes.min && !changes.min.isFirstChange()) {
      this.$onInit();
    }
    if (changes.max && !changes.max.isFirstChange()) {
      this.$onInit();
    }
  };

  hourUp() {
    let updatedDate = this.moment(this.timestamp).add(1, 'hour').valueOf();
    this.onChange({time: updatedDate});
  }

  hourDown() {
    let updatedDate = this.moment(this.timestamp).subtract(1, 'hour').valueOf();
    this.onChange({time: updatedDate});
  }

  minuteUp() {
    var updatedDate = this.moment(this.timestamp).add(this.ticks, 'minute').valueOf();
    this.onChange({time: updatedDate});
  }

  minuteDown() {
    var updatedDate = this.moment(this.timestamp).subtract(this.ticks, 'minute').valueOf();
    this.onChange({time: updatedDate});
  }

  amPmToggle() {
    this.amPm = _.isEqual(this.amPm, 'am') ? 'pm' : 'am';
  }

  private setDisability() {
    var max = this.moment(this.max).startOf('minute').valueOf();
    var min = this.moment(this.min).startOf('minute').valueOf();
    this.disabled = {
      hourUp: this.moment(this.timestamp).add(1, 'hour').startOf('minute').valueOf() > max,
      hourDown: this.moment(this.timestamp).subtract(1, 'hour').startOf('minute').valueOf() < min,
      minuteUp: this.moment(this.timestamp).add(this.ticks, 'minute').startOf('minute').valueOf() > max,
      minuteDown: this.moment(this.timestamp).subtract(this.ticks, 'minute').startOf('minute').valueOf() < min
    };
  }

  private initTimes() {
    this.minHour = this.moment(this.min).get('hour');
    this.minMinute = this.moment(this.min).get('minute');
    this.maxHour = this.moment(this.max).get('hour');
    this.maxMinute = this.moment(this.max).get('minute');

    this.hour = this.moment(this.timestamp).get('hour');
    this.minute = this.moment(this.timestamp).get('minute');
  }

}


angular
  .module('bringoz.admin.commons')
  .component('bringozSetTime', {
    bindings: {
      country: '<',
      min: '<',
      max: '<',
      timestamp: '<',
      ticks: '<',
      amPm: '<?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-set-time/bringoz-set-time.html',
    controller: BringozSetTimeComponent
  });
